import { render, staticRenderFns } from "./thumb-image.vue?vue&type=template&id=713ffe95&"
import script from "./thumb-image.vue?vue&type=script&lang=js&"
export * from "./thumb-image.vue?vue&type=script&lang=js&"
import style0 from "./thumb-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports